import { Icon as IconAnt } from 'antd'
import styled from 'styled-components'

export const FormItem = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;

  .ant-form-item {
    margin-bottom: 0;
  }
`

export const Title = styled.div`
  display: flex;
`

export const Icon = styled(IconAnt)`
  padding-left: 1rem;
`
